
import { Alert, AlertTitle } from "@mui/material";

export const AlertaAmparo = () => {

    return (
        <Alert
            severity="error"
            variant="outlined"
             sx={{
                textAlign: "center",
                "& .MuiAlert-message": {
                    width: "100%",
                },
            }}
        >
            <AlertTitle sx={{ textAlign: "center" }}>

                <strong>Atención</strong>: Este medio <strong>NO PERMITE</strong>{" "}

                ingresar documentos relacionados con <strong>AMPARO</strong> (inicial, promociones, etc).

            </AlertTitle>

            <span style={{ display: "block", marginTop: 8 }}>

                Diríjase a la Oficialía de Partes que corresponda o al Juzgado según
                sea el caso.

            </span>

        </Alert>
    );
};